/** Turns a URL in a stable key */
export const getQueryKey = (url) => [
    url.href,
    url.pathname,
    ...Array.from(url.searchParams.entries())
        .sort((a, b) => Number(a[0] > b[0]) - 1)
        .flat(),
].join("");
